// Allgemeine Chart-Variablen
window.chartAnimationDuration = 2730
window.chartColumnBorderRadius = "4px"
window.chartFontColorGrau = "#84898C"
window.chartFontColorSchwarz = "#2F3435"
window.chartFontSizeKlein = "12px"
window.chartFontSizeMittel = "14px"

// ################## Farben #########################
// Vermoegensstruktur und Liquiverlauf
window.farbeBruttovermoegen = "#FFC857"
window.farbeVerbindlichkeiten = "#869284"
window.farbeNettovermoegen = "#2A90EA"
window.farbeEinnahmen = "#9FD356"
window.farbeAusgaben = "#B74F6F"
window.farbeLiquidierung = "#0F4C81"
window.farbeRot = "#BB2649"

// Vermoegensstruktur Vermoegenswerte
window.kapitalanlagen = "#5CADFF"
window.farbeSonstigeVermoegenswerte = "#B7B3A1"
window.farbeImmobilien = "#8B1E3F" // alternativ "##F18F01" oder "#FF7B25"
window.farbeUnternehmen = "#1B4353"

// Anlageklassen
window.farbeAktien = "#1293B8"
window.farbeAnleihen = "#A7CECB"
window.farbeCash = "#7BAE7F"
window.farbeSonstiges = "#B59C92"

// Kredite
window.farbeVerbindlichkeitenColumn = "#7F8C7D"
window.farbeZinsen = "#B74F6F"
window.farbeTilgung = "#1D70A2"
window.farbeSondertilgungen = "#4D9DE0"
window.farbeSondertilgungspotential = "rgba(77,157,224,0.15)"
window.farbeTilgungssurrogat = "#B9CEDF"
window.farbeKreditSteuerwirksam = "#41474E"
window.farbeKreditNichtSteuerwirksam = "#A5AAB6" //"#B0B4BF";

// Steuer
window.farbeSummeDerEinkuenfte = "#C3D9E9"
window.farbeZuVersteuerndesEinkommen = "#5B96C2"
window.farbeSteuerBetrag = "#075688"
window.farbeSteuererstattung = "#4DAA57"
window.farbeZuVersteuernderKapitalertrag = "#995D81"

// Sozialversicherungspflichtig
window.farbeSozialpflichtigesEinkommen = "#FFBE98"

// Sonstiges
window.farbeVergangenheit = "#8BA6A9"
window.farbeDeckungsstock = "#8BA6A9"
window.farbeKosten = "#C46F89"
window.farbeZulagen = "#F28F43"

// Beitraege und Leistung
window.farbeBeitrag1 = "#604c8d" //'#044389'
window.farbeBeitrag2 = "#D89A9E" //'#A187C0'  //'#1988C8'
window.farbeBeitrag3 = "#8EB1C7"
window.farbeLeistung = "#FFBE98" // alte Farbe "#FFB485"

// Depot im Unternehmen
window.farbeKapitalertraegeUnternehmen = "#FBBA72"
window.farbeSteuerbetraegeUnternehmen = "#604D53"

window.svgPfeilLinks =
	'<svg class="fill-farbe-grau size-6" version="1.1" id="glyphicons-basic" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"y="0px" viewBox="0 0 32 32" style="enable-background:new 0 0 32 32;" xml:space="preserve"><path id="chevron-left" d="M22.9,23.4c0.2,0.2,0.2,0.5,0,0.7l-2.8,2.8c-0.2,0.2-0.5,0.2-0.7,0L9.2,16.7c-0.4-0.4-0.4-1,0-1.4l0,0L19.4,5.1c0.2-0.2,0.5-0.2,0.7,0l2.8,2.8c0.2,0.2,0.2,0.5,0,0.7L15.6,16L22.9,23.4z"/></svg>'
window.svgPfeilRechts =
	'<svg class="fill-farbe-grau size-6" version="1.1" id="glyphicons-basic" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"y="0px" viewBox="0 0 32 32" style="enable-background:new 0 0 32 32;" xml:space="preserve"><path id="chevron-right" d="M22.8,16.7L12.6,26.9c-0.2,0.2-0.5,0.2-0.7,0l-2.8-2.8c-0.2-0.2-0.2-0.5,0-0.7l7.4-7.4L9.1,8.6c-0.2-0.2-0.2-0.5,0-0.7l2.8-2.8c0.2-0.2,0.5-0.2,0.7,0l10.2,10.2C23.2,15.7,23.2,16.3,22.8,16.7C22.8,16.7,22.8,16.7,22.8,16.7z"/></svg>'
